import moment from 'moment'

export default (dateString) => {
  let age = moment().diff(dateString,'years',false)
  return age
}
